import { useState } from "react";
import { FleetAttachment, FleetStatus } from "../types/FleetManagement.types";
import { BookingProperty } from "../../FacilityManager/Domain/Types/FloorPlan/BookingProperty.type";
import { FileObject } from "../../../features/FileDropzone/typings/FileObject.type";

export type FleetEditDraftState = {
  imageFiles: FileObject[];
  setImageFiles: React.Dispatch<React.SetStateAction<FileObject[]>>;
  showBiggerImages: string[] | null;
  setShowBiggerImages: React.Dispatch<React.SetStateAction<string[] | null>>;
  picturePathsToDelete: string[];
  setPicturePathsToDelete: React.Dispatch<React.SetStateAction<string[]>>;
  attachmentDraft: FleetAttachment[];
  setAttachmentDraft: React.Dispatch<React.SetStateAction<FleetAttachment[]>>;
  propertiesDraft: BookingProperty[];
  setPropertiesDraft: React.Dispatch<React.SetStateAction<BookingProperty[]>>;
  statusDraft: FleetStatus | null;
  setStatusDraft: React.Dispatch<React.SetStateAction<FleetStatus | null>>;
  blockedReasonDraft: string | null;
  setBlockedReasonDraft: React.Dispatch<React.SetStateAction<string | null>>;
  validationErrors: Record<string, string | undefined>;
  setValidationErrors: React.Dispatch<React.SetStateAction<Record<string, string | undefined>>>;
  resetDraft: () => void;
};

export const useFleetEditDraft = (): FleetEditDraftState => {
  const [imageFiles, setImageFiles] = useState<FileObject[]>([]);
  const [showBiggerImages, setShowBiggerImages] = useState<string[] | null>(null);
  const [picturePathsToDelete, setPicturePathsToDelete] = useState<string[]>([]);
  const [attachmentDraft, setAttachmentDraft] = useState<FleetAttachment[]>([]);
  const [propertiesDraft, setPropertiesDraft] = useState<BookingProperty[]>([]);
  const [statusDraft, setStatusDraft] = useState<FleetStatus | null>(null);
  const [blockedReasonDraft, setBlockedReasonDraft] = useState<string | null>(null);
  const [validationErrors, setValidationErrors] = useState<Record<string, string | undefined>>({});

  const resetDraft = () => {
    setImageFiles([]);
    setShowBiggerImages(null);
    setPicturePathsToDelete([]);
    setAttachmentDraft([]);
    setPropertiesDraft([]);
    setStatusDraft(null);
    setBlockedReasonDraft(null);
    setValidationErrors({});
  };

  return {
    imageFiles,
    setImageFiles,
    showBiggerImages,
    setShowBiggerImages,
    picturePathsToDelete,
    setPicturePathsToDelete,
    attachmentDraft,
    setAttachmentDraft,
    propertiesDraft,
    setPropertiesDraft,
    statusDraft,
    setStatusDraft,
    blockedReasonDraft,
    setBlockedReasonDraft,
    validationErrors,
    setValidationErrors,
    resetDraft
  };
};
